import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Step8 from "../components/CreateListingSummery/Step8";
import Step7 from "../components/CreateListingSummery/Step7";
import Step6 from "../components/CreateListingSummery/Step6";
import Step5 from "../components/CreateListingSummery/Step5";
import Step4 from "../components/CreateListingSummery/Step4";
import Step3 from "../components/CreateListingSummery/Step3";
import Step2 from "../components/CreateListingSummery/Step2";
import Step1 from "../components/CreateListingSummery/Step1";
import axiosInstance from "../redux/helpers/axios";

const CreateListingSummery = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const totalStep = 8;
  const [steps, setSteps] = useState(1);
  const currentStep = +location?.search?.split("=")[1];
  const data = location.state;

  const [firstImg, setFirstImg] = useState(null);
  const [secondImg, setSecondImg] = useState(null);

  const [conditionSelected, setConditionSeleted] = useState(null);

  const [selected, setSelected] = useState(null);
  const [images, setImages] = useState([]);

  const [formData1, setFormData1] = useState({
    listingTitle: "",
  });

  const [formData2, setFormData2] = useState({
    production: "",
    gender: "",
    serial: "",
    dialColor: "",
    caseDiameterX: "",
    caseDiameterY: "",
    movement: "",
    caseMaterial: "",
    braceletColor: "",
    braceletMaterial: "",
  });

  const [formData3, setFormData3] = useState({
    price: "",
    currency: "USD",
    price2: "",
    currency2: "USD",
  });

  const handleNextStep = (stepNo) => {
    if (stepNo < 9) {
      setSteps((current) => stepNo);
      navigate(`/listing/create-listing?stepNo=${stepNo}`, { state: data });
    } else handleSubmit();
  };

  const handleSubmit = async () => {
    const data2 = {
      listingTitle: formData1.listingTitle,
      model: data?.title,
      brand: data?.manufacturer,
      refId: data?.refId,
      movement: formData2.movement,
      production: formData2.production,
      gender: formData2.gender,
      serial: formData2.serial,
      caseDetails: {
        caseDiameterX: formData2.caseDiameterX,
        caseDiameterY: formData2.caseDiameterY,
        caseMaterial: formData2.caseMaterial,
      },
      braceletDetails: {
        braceletColor: formData2.braceletColor,
        braceletMaterial: formData2.braceletMaterial,
      },
      scopeOfDelivery: selected,
      gallery: images,
      ownershipProof: {
        firstImg: firstImg,
        secondImg: secondImg,
      },
      watchCondition: {
        isNew: true,
        type: conditionSelected,
      },
      description: "N/A",
      pricing: {
        dealerPrice: formData3.price,
        dealerCurrency: formData3.currency,
        userPrice: formData3.price2,
        userCurrency: formData3.currency2,
      },
    };
    await axiosInstance.post("/private/listing/create", data2);
    navigate("/user/my-inventory");
  };

  const handleSaveAndClose = () => {
    const data2 = {
      listingTitle: formData1.listingTitle,
      model: data?.title,
      brand: data?.manufacturer,
      refId: data?.refId,
      movement: formData2.movement,
      production: formData2.production,
      gender: formData2.gender,
      serial: formData2.serial,
      caseDetails: {
        caseDiameterX: formData2.caseDiameterX,
        caseDiameterY: formData2.caseDiameterY,
        caseMaterial: formData2.caseMaterial,
      },
      braceletDetails: {
        braceletColor: formData2.braceletColor,
        braceletMaterial: formData2.braceletMaterial,
      },
      scopeOfDelivery: selected,
      gallery: images,
      ownershipProof: {
        firstImg: firstImg,
        secondImg: secondImg,
      },
      watchCondition: {
        isNew: true,
        type: conditionSelected,
      },
      description: "N/A",
      pricing: {
        dealerPrice: formData3.price,
        dealerCurrency: formData3.currency,
        userPrice: formData3.price2,
        userCurrency: formData3.currency2,
      },
    };
    let draft = localStorage.getItem("draft") || [];
    // const newDraft = draft.push(data2);
    localStorage.setItem("draft", JSON.stringify([...draft, data2]));
    navigate("/user/my-inventory");
  };

  // console.log(location?.search?.split("=")[1]);

  return (
    <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12 border-y">
      {/* PAGES TO APPEAR */}
      <div className="lg:w-7/12 md:w-8/12 sm:w-full mx-auto pb-20">
        {currentStep === 1 && (
          <Step1
            data={data}
            formData1={formData1}
            setFormData1={setFormData1}
          />
        )}
        {currentStep === 2 && (
          <Step2
            data={data}
            formData1={formData2}
            setFormData1={setFormData2}
          />
        )}
        {currentStep === 3 && (
          <Step3 selected={selected} setSelected={setSelected} />
        )}
        {currentStep === 4 && <Step4 images={images} setImages={setImages} />}
        {currentStep === 5 && (
          <Step5
            firstImg={firstImg}
            setFirstImg={setFirstImg}
            secondImg={secondImg}
            setSecondImg={setSecondImg}
          />
        )}
        {currentStep === 6 && (
          <Step6
            conditionSelected={conditionSelected}
            setConditionSeleted={setConditionSeleted}
          />
        )}
        {currentStep === 7 && (
          <Step7 formData1={formData3} setFormData1={setFormData3} />
        )}
        {currentStep === 8 && (
          <Step8
            handleNextStep={handleNextStep}
            data={data}
            formData1={formData1}
            formData2={formData2}
            priceData={formData3}
            firstImg={firstImg}
            secondImg={secondImg}
            selected={selected}
            images={images}
            conditionSelected={conditionSelected}
          />
        )}
      </div>
      {/* PROGRESSBAR */}
      <div className="w-full rounded-full h-1.5 bg-primary grid grid-cols-8">
        {Array.from({ length: totalStep }).map((_, index) => (
          <div
            key={index}
            className={`h-full flex-1 ${index === 0 && "rounded-l-full"} ${
              index === totalStep - 1 && "rounded-r-full"
            }  ${index < currentStep ? "bg-secondary" : "bg-gray-300"}`}
          ></div>
        ))}
      </div>
      {/* CTA */}
      <div className="flex justify-between items-center w-full my-6">
        <button
          onClick={() => handleSaveAndClose()}
          className="text-sm flex gap-1 items-center underline"
        >
          Save and close{" "}
        </button>
        <button
          onClick={() => {
            handleNextStep(currentStep + 1);
          }}
          className="px-12 py-2.5 rounded bg-secondary text-white text-sm"
        >
          Next
        </button>
      </div>
    </section>
  );
};

export default CreateListingSummery;
